var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-submission-card-content-label"},[_vm._v("\n    "+_vm._s(_vm.question)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }